var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C2.47 0 0 2.47 0 5.5V16.5C0 19.53 2.47 22 5.5 22H19.0508C21.3608 18.39 25.4 16 30 16C32.85 16 35.4909 16.9205 37.6309 18.4805C37.8709 17.8705 38 17.2 38 16.5V5.5C38 2.47 35.53 0 32.5 0H5.5ZM9 9C10.1 9 11 9.9 11 11C11 12.1 10.1 13 9 13C7.9 13 7 12.1 7 11C7 9.9 7.9 9 9 9ZM19 9C20.1 9 21 9.9 21 11C21 12.1 20.1 13 19 13C17.9 13 17 12.1 17 11C17 9.9 17.9 9 19 9ZM29 9C30.1 9 31 9.9 31 11C31 12.1 30.1 13 29 13C27.9 13 27 12.1 27 11C27 9.9 27.9 9 29 9Z",
    fill: "#4099FF",
    className: "ChangePasswordicon1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18C23.925 18 19 22.925 19 29C19 35.075 23.925 40 30 40C36.075 40 41 35.075 41 29C41 22.925 36.075 18 30 18ZM30 22C31.924 22 33.709 22.8049 35 24.1289V23C35 22.448 35.447 22 36 22C36.553 22 37 22.448 37 23V27C37 27.552 36.553 28 36 28H32C31.447 28 31 27.552 31 27C31 26.448 31.447 26 32 26H33.9609C33.0359 24.772 31.589 24 30 24C27.243 24 25 26.243 25 29C25 31.757 27.243 34 30 34C32.11 34 34.003 32.661 34.709 30.668C34.893 30.147 35.4634 29.8736 35.9844 30.0586C36.5054 30.2436 36.7788 30.814 36.5938 31.334C35.6068 34.125 32.956 36 30 36C26.141 36 23 32.86 23 29C23 25.14 26.141 22 30 22Z",
    fill: "#CFE6FF",
    className: "ChangePasswordicon2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/Change-Password.089759a7.svg";
export { ForwardRef as ReactComponent };